import React, {Component} from 'react';
import PropTypes from "prop-types";
import {change, Field} from 'redux-form';
import {compose} from "recompose";
import {connect} from "react-redux";
import axios from 'axios';
import {RESOURCES as systemResources} from '../fuseSystemsResourceMap';
import {
    required
} from 'admin-on-rest';
import FuseTheme from "../global/theme";
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import ContentSubmit from 'material-ui/svg-icons/image/remove-red-eye';

/**
 * Set a field for form entry
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
const renderInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) => {
    return (
        <TextField
            errorText={touched && error}
            {...inputProps}
            {...props}
            fullWidth
        />
    )
};

/**
 * Checks for validation errors
 *
 * @return {*}
 */
const handleRequiredValidation = () => {
    let error = null;
    if (this.state) {
        if (this.state.inputValue && this.state.needToValidate) {
            error = this.props.errorRequiredMessage;
        }
        this.setState({
            isValid: (!error),
            showSuccessMessage: !!(error)
        });
    }
    return error;
};

const validateRequired = [required, handleRequiredValidation];

/**
 * A Text Input that verifies the uniqueness of its value.
 *
 */
class ValidatedInputField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageText: null,
            inputValue: null,
            isDuplicate: false,
            isValid: false,
            needToValidate: true,
            showSuccessMessage: false,
            sourceValue: null,
            submitting: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckClick = this.handleCheckClick.bind(this);
    }

    /**
     * Handle input field change event
     *
     * @param event
     * @param index
     * @param value
     */
    handleInputChange(event, index, value) {
        this.setState({
            inputValue: index,
            isDuplicate: false,
            isValid: false,
            needToValidate: true,
            sourceValue: null
        });
        this.props.dispatch(change('record-form', this.props.source, null));
    }

    /**
     * Handle button click event
     *
     * @param event
     */
    handleCheckClick = (event) => {
        event.preventDefault();
        if (this.state && this.state.inputValue) {
            this.checkAvailability();
        }
    };

    /**
     * Fetch single item from provided resource
     *
     */
    checkAvailability() {
        const params = {};
        // Set this field's source value (usually id) for URL parameters
        params[this.props.source] = this.state.inputValue;
        const resource = systemResources[this.props.fieldResource].GET_ONE(params);

        let isValid = true;
        let isDuplicate = false;
        let needToValidate = false;
        let sourceValue = this.state.inputValue;

        // Retrieve the data if it exists
        this.setState({
            isDuplicate: isDuplicate,
            isValid: isValid,
            needToValidate: needToValidate,
            showSuccessMessage: false,
            sourceValue: sourceValue,
            submitting: true
        });

        import('../shared/functions')
            .then(functions => {
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload && typeof result.data.payload === 'object') {
                        isDuplicate = true;
                        isValid = false;
                        needToValidate = true;
                        sourceValue = null;

                        // Set the state for result (duplicate) or error (available)
                        this.setState({
                            isDuplicate: isDuplicate,
                            isValid: isValid,
                            needToValidate: needToValidate,
                            showSuccessMessage: true,
                            sourceValue: sourceValue,
                            submitting: false
                        });
                        this.props.dispatch(change('record-form', this.props.source, sourceValue));
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        //console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                    // Set the state for result (duplicate) or error (available)
                    this.setState({
                        isDuplicate: isDuplicate,
                        isValid: isValid,
                        needToValidate: needToValidate,
                        showSuccessMessage: true,
                        sourceValue: sourceValue,
                        submitting: false
                    });
                    this.props.dispatch(change('record-form', this.props.source, sourceValue));
                });
            });

        this.setState({
            messageText: (this.state.isValid) ? this.props.errorDuplicateMessage : ''
        });
    }

    render() {
        const {
            buttonLabel,
            errorDuplicateMessage,
            errorRequiredMessage,
            label,
            source,
            successMessage
        } = this.props;

        const styles = {
            buttonContainer: {
                display: 'inline-block',
                margin: '16px 0 0 1em',
                verticalAlign: 'top',
            },
            errorText: {
                display: 'block',
                fontSize: 12,
                color: FuseTheme.palette.errorColor,
                margin: '0 0 1em 0',
            },
            field: {
                width: 256,
                marginTop: '-14px',
            },
            hidden: {
                display: 'none',
                visibility: 'none',
            },
            loader: {
                display: 'inline-block',
                margin: '0 0 0 8px',
                verticalAlign: 'middle',
            },
            messageText: {
                display: 'block',
                fontSize: 12,
                color: FuseTheme.palette.correctColor,
                margin: '0 0 1em 0',
            },
        };

        return (
            <div>
                {/* Entry field and source field */}
                <Field key={`input-${source}`}
                       name={`${source}_check`}
                       type={this.props.fieldType}
                       component={renderInput}
                       floatingLabelText={label}
                       onChange={this.handleInputChange}
                       validate={validateRequired}
                       style={styles.field}
                />
                <Field key={`input-value-${source}`}
                       name={source}
                       component="input"
                       type="text"
                       value={this.state.sourceValue}
                       style={styles.hidden}
                />
                <span style={styles.buttonContainer}>
                    <RaisedButton
                        primary
                        type="button"
                        icon={<ContentSubmit/>}
                        label={buttonLabel}
                        disabled={!this.state.inputValue}
                        onClick={this.handleCheckClick}/>
                </span>
                {this.state.submitting &&
                <CircularProgress
                    size={20}
                    thickness={2}
                    style={styles.loader}
                />
                }
                <div key={`message-${source}`}>
                    {this.state.showSuccessMessage &&
                    <span>
                        {/* Display duplicated/unavailable messaging */}
                        {this.state.isDuplicate &&
                        <span style={styles.errorText}>{errorDuplicateMessage}</span>
                        }
                        {/* Display required messaging */}
                        {this.state.needToValidate &&
                        <span style={styles.errorText}>{errorRequiredMessage}</span>
                        }
                        {/* Display success/available messaging */}
                        {this.state.inputValue && this.state.isValid && !this.state.isDuplicate && !this.state.needToValidate &&
                        <span style={styles.messageText}>{successMessage}</span>
                        }
                    </span>
                    }
                </div>
            </div>
        )
    }
}

ValidatedInputField.propTypes = {
    addField: PropTypes.bool,
    buttonLabel: PropTypes.string,
    errorDuplicateMessage: PropTypes.string,
    errorRequiredMessage: PropTypes.string,
    fieldResource: PropTypes.string.isRequired,
    fieldType: PropTypes.string,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    source: PropTypes.string.isRequired,
    successMessage: PropTypes.string,
};

ValidatedInputField.defaultProps = {
    addField: true,
    buttonLabel: "Check Availability",
    errorDuplicateMessage: "This value already exists.",
    errorRequiredMessage: "This value must be unique.",
    fieldType: "text",
    isRequired: true,
    successMessage: "This value is available.",
};

const enhance = compose(
    connect()
);

export default enhance(ValidatedInputField);


// WEBPACK FOOTER //
// ./src/Fuse/components/ValidatedInputField.js